import React from 'react';
import moon from '../../../images/moonp.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import Typical from 'react-typical'
import Fade from 'react-reveal/Fade';
import './HeaderMain.css';

const HeaderMain = () => {
    return (
        <main className="row g-0 d-flex align-items-center my-5">
            <div className="col-md-6 offset-md-1 px-5">
                <Fade left>
                <h1 className="text-warning">Hello, I am </h1>
                <h1 className="text-light">Moon Saha Chowdhury</h1>
                <div className='text-warning'>
                    <Typical
                        steps={['Front End Developer', 2000, 'React Developer', 1000, 'MERN Stack Developer', 500]}
                        loop={Infinity}
                        wrapper="h3"
                    />
                </div>


                <p className="text-white text-sm-start p-2">An enthusiastic and self-motivated web developer with some knowledge of frameworks for frontend and backend development. I have a desire to pursue a career with challenging targets so that I can use my qualification, leadership, creative, and interpersonal capabilities to provide the highest level of technical support.</p>
                <ul className="social-media list-inline">
                    <li className="list-inline-item"><a href="https://github.com/moon-saha-chowdhury" target="_blank"><FontAwesomeIcon className="icon active-icon" icon={faGithub} /></a></li>
                    <li className="list-inline-item"><a href="https://www.linkedin.com/in/moon-saha-chowdhury-aa00a2211/" target="_blank"><FontAwesomeIcon className="icon" icon={faLinkedin} /></a></li>
                    <li className="list-inline-item"><a href="https://mail.google.com/mail/u/0/" target="_blank"><FontAwesomeIcon className="icon" icon={faEnvelope} /></a></li>
                </ul>
                <a className="btn btn-warning fw-bold" href="https://drive.google.com/uc?export=download&id=1F_c4It16cRJI-xxjG--Q7MPojea7VWpl" target="_blank"><FontAwesomeIcon icon={faDownload} /> GET MY RESUME</a>

                </Fade>
            </div>
            <div className="col-md-5">
                <Fade right>
                    <img src={moon} alt="" className="img-fluid w-50 ms-5" />

                </Fade>
            </div>

        </main>
    );
};

export default HeaderMain;